/* RESPONSIBLE TEAM: team-actions */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';
import type RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type AppService from 'embercom/services/app-service';

class AutomationFinAIAgentProcedureRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare router: RouterService;

  async beforeModel() {
    if (this.appService.app.canUseStandalone) {
      let params: { id: string } = this.paramsFor(
        'apps.app.automation.fin-ai-agent.procedures.procedure',
      ) as unknown as { id: string };
      if (params.id) {
        this.router.transitionTo('apps.app.standalone.procedures.procedure.preview', params.id);
        return;
      }
    }

    if (!this.appService.app?.canUseFinProcedures) {
      this.router.transitionTo('apps.app.automation.fin-ai-agent.tasks');
    }
  }

  get titleToken() {
    // TODO: Set procedure title from loaded data if available
    return this.intl.t('ai-agent.new-submenu.procedures');
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAIAgentProcedureRoute, { overrideRenderTemplate: false });
